import { Query, Transfer } from '@varo/graphql-schema-types';
import { useCallback } from 'react';
import GetAllTransfers from 'services/graphql/queries/MoveMoney/GetAllTransfers';
import usePaginatedBaseQuery from 'shared/hooks/usePaginatedBaseQuery';

const useTransferHistory = () => {
  const extractTransfers = useCallback(
    (data: Query) => ({
      edges: data?.transfers?.edges ?? [],
      pageInfo: {
        hasNextPage: !!data?.transfers?.pageInfo?.hasNextPage,
        endCursor: data?.transfers?.pageInfo?.endCursor ?? null,
      },
    }),
    [],
  );

  return usePaginatedBaseQuery<Transfer>({
    query: GetAllTransfers,
    extractDataCallback: extractTransfers,
  });
};

export default useTransferHistory;
